<template>
    <div class="contenido">
        <Titulo titulo="GALERÍA DE IMAGENES"/>

        <b-container>
            <div class="accordion mt-3 mb-5" role="tablist">

                <b-card no-body class="mb-1" v-for="(gal, index) in galerias" :key="index">
                    <b-card-header @click="traerFotos(gal.id_galeria)"  header-tag="header" class="p-1" role="tab">
                        <b-button block v-b-toggle:[`collapse-${gal.id_galeria}`] variant="primary">{{ gal.nombre }}</b-button>
                    </b-card-header>
                    
                    <b-collapse :id="`collapse-${gal.id_galeria}`" accordion="my-accordion" role="tabpanel">
                        <b-card-body>
                            <b-card-text class="text-center">{{ gal.descripcion }}</b-card-text>

                            <b-card-group columns>
                                <a href="#" v-for="(item, index) in fotosgaleria" :key="item.id_foto" @click="mostrarFoto(index)">
                                    <b-card :img-src="item.foto" img-alt="foto" overlay></b-card>
                                </a>
                            </b-card-group>
                        </b-card-body>
                    </b-collapse>
                </b-card>
            </div>
        </b-container>

        <b-modal 
            id="modalFoto" size="lg" centered 
            class="p-0"
        >
            <b-carousel
                id="carousel-1"
                    v-model="slide"
                    :interval="5000"
                    controls
                    indicators
                    background="#ababab"
                    img-width="1600"
                    img-height="640"
                    style="text-shadow: 1px 1px 2px #333;"
                    @sliding-start="onSlideStart"
                    @sliding-end="onSlideEnd"
                >
                
                <b-carousel-slide v-for="foto in fotosgaleria" :key="foto.id_foto"
                    :img-src="foto.foto"
                >
                </b-carousel-slide>
            </b-carousel>

            <template #modal-footer>
                <div class="w-100"></div>
            </template>
        </b-modal>
    </div>
</template>

<script>
import Titulo from '@/components/Titulo.vue'
import axios from 'axios'
import {mapState} from 'vuex'

export default {
    name: 'Galeria',
    props: {
    },
    components: {
        Titulo
    },
    data() {
        return {
            galerias: [],
            fotosgaleria: [],
            // control de carrusel
            slide: 0,
            sliding: null,
        }
    },
    created() {
        this.traerGalerias()
    },
    mounted() {
        this.$root.$on('bv::collapse::state', (collapseId, isJustShown) => {
            console.log('collapseId:', collapseId)
            console.log('isJustShown:', isJustShown)
        })
    },
    methods: {
        traerGalerias() {
            var formData = new FormData();
            formData.append("accion", "mostrarDatos");
            formData.append("tabla", "galerias");
            formData.append("ordenamiento", `nombre`);
            
            axios.post(`${this.url}/ajax/ajax.generico.php`, formData)
            .then((res) => {
                this.galerias = res.data
            });
        },
        traerFotos(idGaleria) {
            var formData = new FormData();
            formData.append("accion", "traerFotos");
            formData.append("idGaleria", idGaleria);
            formData.append("rutaFoto", `${this.url}/doctos/galeria_imagenes/`)
            
            axios.post(`${this.url}/ajax/ajax.galerias.php`, formData)
            .then((res) => {
                this.fotosgaleria = res.data
            });
        },
        mostrarFoto(index) {
            this.slide = index
            
            this.$bvModal.show('modalFoto')
        },
        onSlideStart(slide) {
            this.sliding = true
        },
        onSlideEnd(slide) {
            this.sliding = false
        }
    },
    computed: {
        url() {
            if ( ["localhost", "127.0.0.1", ""].includes(window.location.hostname) ) {
                return this.urlSandbox
            } else {
                return this.urlProd
            }
        },
        ...mapState(['urlProd']),
        ...mapState(['urlSandbox'])
    }
}
</script>

<style scoped>
.contenido{
    min-height: 500px;
}
</style>